module.exports = __webpack_public_path__ + "static/media/photo-right-first.57281dff.png";